export enum CustomerEmailType {
    DELIVERY_ORDER_CONFIRMATION = "DELIVERY_ORDER_CONFIRMATION",
    TAKEAWAY_ORDER_CONFIRMATION = "TAKEAWAY_ORDER_CONFIRMATION"
}